// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stories-list__stories-container[data-v-60a79eaa]{margin-top:5px;display:flex;flex-wrap:wrap;align-content:flex-start;justify-content:space-between;align-items:flex-start}@media all and (max-width: 766px){.stories-list__create-button[data-v-60a79eaa]{text-align:right}}\n", ""]);
// Exports
module.exports = exports;
